import { AuditIcon } from '@app/modules/audit/components/AuditIcon';
import { PropsWithChildren } from 'react';
import { useIntl } from 'react-intl';
import { Page } from '../../../../../components/page/Page';
import { getAuditGlobalReportsLinks } from '../../../components/screen/ReportsLinks';

type Props = PropsWithChildren<{
  title?: string;
}>;

export function BaseGlobalReportPage({ children }: Props) {
  const { $t } = useIntl();

  const title = $t({
    id: 'audit.globalReports.title',
    defaultMessage: 'Audit global',
  });

  return (
    <Page htmlTitle={title}>
      <Page.Header
        icon={<AuditIcon />}
        title={[
          $t({
            id: 'audit.title',
            defaultMessage: 'Auditoría',
          }),
          $t({
            id: 'audit.globalReports.title',
            defaultMessage: 'Audit global',
          }),
        ]}
        tabs={getAuditGlobalReportsLinks($t)}
      />
      {children}
    </Page>
  );
}
